var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerfectQuality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 2.94092V17.9409M40.5 62.9409V77.9409M13.9875 13.9284L24.6 24.5409M56.4 56.3409L67.0125 66.9534M3 40.4409H18M63 40.4409H78M13.9875 66.9534L24.6 56.3409M56.4 24.5409L67.0125 13.9284",
    stroke: "#4DBD94",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8253 13.5941L47.2952 24.3328M33.7048 56.549L29.1747 67.2877M29.5263 13.4532L33.9189 24.2559M47.0811 56.6259L51.4737 67.4286M13.6532 29.1156L24.3919 33.6457M56.608 47.2361L67.3468 51.7662M13.5123 51.4146L24.315 47.022M56.6849 33.8598L67.4876 29.4672",
    stroke: "#F7FCFD",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47 34.9409L36 45.9409L31 40.9409",
    stroke: "#4DBD94",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfectQuality);
export default __webpack_public_path__ + "static/media/PerfectQuality.0cbba7cf6cddf01c16faaa3f98daa44e.svg";
export { ForwardRef as ReactComponent };